import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { dashboardColors } from '../constants';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export const DonutChart = ({ wind, biogas, pv, allData, loading }) => {
  const { windColor, pvColor, bioGColor } = dashboardColors;
  const settings = {
    labels: ['Wind', 'Photovoltaik', 'Biogas'],
    datasets: [
      {
        label: 'Erzeugung',
        data: [wind, pv, biogas],
        backgroundColor: [windColor, pvColor, bioGColor],
        spacing: 2,
        cutout: '60%',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',

        labels: {
          boxWidth: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 14);
            return size;
          },
          color: '#333',
          font: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 20);
            return {
              size: size,
            };
          },
        },
      },
      tooltip: {
        enabled: true,
        bodyFont: function (context) {
          const width = context.chart.width;
          const size = Math.round(width / 20);
          return {
            size: size,
          };
        },
        callbacks: {
          label: function (ctx) {
            return `${ctx.dataset.data[ctx.dataIndex]
              .toFixed(2)
              .replace('.', ',')} kW`;
          },
        },
      },

      datalabels: {
        display: (wind + biogas + pv).toFixed(0) > 0 ? true : false,
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.dataset.data;
          dataArr.map((data) => {
            return (sum += data);
          });
          let percentage = allData
            ? `${Math.abs(((value * 100) / sum).toFixed(0))}%`
            : '0%';
          return percentage;
        },
        color: [windColor, pvColor, bioGColor],
        borderRadius: 20,
        borderColor: [windColor, pvColor, bioGColor],
        borderWidth: 2,
        padding: 5,
        backgroundColor: '#fff',
        font: function (context) {
          const width = context.chart.width;
          const size = Math.round(width / 18);
          return {
            size: size,
            weight: 'bold',
          };
        },
      },
    },
  };

  return (
    <div className='col-sm-6 '>
      <h2 className='fs-4 text-center pb-3'>Erzeugung</h2>
      <div className=' position-relative'>
        <Doughnut
          data={settings}
          plugins={[ChartDataLabels]}
          options={options}
        />
        <h4
          className=' position-absolute start-50 translate-middle  m-0 text-center'
          style={{
            top: '45%',
            fontSize: 'calc(12px + 1.8vw)',
          }}
        >
          {allData ? `${(wind + biogas + pv).toFixed(0)} kW` : '0 kW'}
        </h4>
      </div>
    </div>
  );
};
